module.exports = __webpack_public_path__ + "img/banner.deaf36bc.png";